import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import styles from "./ApplicationCreatedModal.module.css";

type Props = {
  companyName?: string;
  iframeProfile?: boolean;
  titleKey?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionLoading?: boolean;
};

const CompanyProfileCompletedModal = ({
  companyName,
  iframeProfile = false,
  titleKey = "profileCompleted",
  actionLabel,
  onAction,
  actionLoading = false,
}: Props) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const title = companyName?.trim() || _t("yourCompany", "Your company");
  const handleGo = () => navigate("/home?welcome=true");

  return (
    <div
      className="popup-overlay wrapper-modal"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
      }}
    >
      <div className={styles.card}>
        <div className={styles.check}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M6 12.5 10 16.5 18 7.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2>{_t(titleKey)}</h2>
        {!iframeProfile && <p className={styles.appTitle}>{title}</p>}
        {actionLabel && onAction ? (
          <button
            className={styles.cta}
            type="button"
            onClick={onAction}
            disabled={actionLoading}
          >
            {actionLoading ? _t("loading") : actionLabel}
          </button>
        ) : (
          !iframeProfile && (
            <button className={styles.cta} type="button" onClick={handleGo}>
              {_t("goToMyDashboard", "Go to my dashboard")}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default CompanyProfileCompletedModal;
